import { render, staticRenderFns } from "./ZeroExInstant.vue?vue&type=template&id=04d4a27e&scoped=true&"
import script from "./ZeroExInstant.vue?vue&type=script&lang=js&"
export * from "./ZeroExInstant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d4a27e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
